import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { RootState } from "../../../redux/rootReducers";
import { resetSession } from "../../../redux/auth";
import {
  getClientMeetUpChecklistAction,
  resetClientDirectoryError,
  resetClientDirectoryFetching,
  resetClientDirectoryMessage,
  resetClientDirectoryStatusCode,
  resetClientDirectorySuccess,
  resetClientMeetUpChecklistData,
  resetSingleClientMeetUpCheklistData,
} from "../../../redux/clientDirectory";
import { GetClientMeetUpChecklistPayloadType } from "../../../commonTypes/clientDirectoryTypes";
import {
  PendingRedIcon,
  PendingWhiteIcon,
  RectangleRedListIcon,
  RectangleWhiteIcon,
  UnauthorizeImage,
  checked,
  checkedWhiteIcon,
} from "../../../assets/images";
import {
  EmptyListPage,
  ErrorSuccessModal,
  TableLoader,
} from "../../../components/commons";
import ClientMeetUpCard from "../../../components/LeadModule/ClientMeetUp/ClientMeetUpCard";
import { SearchIcon } from "../../../components/Icon";
import useDebounce from "../../../customHooks/useDebounce";
import toast, { Toaster } from "react-hot-toast";
import {
  ClientMeetUpCheckListType,
  ClientMeetUpDataType,
} from "../../../redux/clientDirectory/clientDirectoryType";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ClientMeetUpSorting from "../../../components/LeadModule/ClientMeetUp/ClientMeetUpSorting";

type AppProps = {
  history: any;
  fetching: boolean;
  message: string | null;
  success: null | number;
  error: null | string;
  statusCode: null | number;
  token: null | string;
  totalCount: any;
  clientMeetUpChecklistData: ClientMeetUpCheckListType;
  dispatchGetClientMeetUpData: (
    data: GetClientMeetUpChecklistPayloadType
  ) => void;
  dipatchResetClientMeetUpChecklistAction: () => void;
  dispatchResetSuccess: () => void;
  dispatchResetError: () => void;
  dispatchResetMessage: () => void;
  dispatchResetStatusCode: () => void;
  dispatchResetFetching: () => void;
  dispatchResetSession: () => void;
  dispatchResetSingleClientMeetUpList: () => void;
};

const ClientMeetUp = ({
  history,
  fetching,
  message,
  success,
  error,
  statusCode,
  token,
  totalCount,
  dispatchGetClientMeetUpData,
  clientMeetUpChecklistData,
  dipatchResetClientMeetUpChecklistAction,
  dispatchResetSuccess,
  dispatchResetError,
  dispatchResetMessage,
  dispatchResetStatusCode,
  dispatchResetFetching,
  dispatchResetSession,
  dispatchResetSingleClientMeetUpList,
}: AppProps) => {
  const persistSortBy = history?.location?.state?.sortBy;
  const persistSearchTerm = history?.location?.state?.searchData;
  const persistMeetingFilter = history?.location?.state?.meetingFilter
  const [data, setData] = useState<ClientMeetUpCheckListType>([]);
  const [limit, setLimit] = useState(20);
  const [offset, setOffset] = useState(0);
  const [searchData, setSearchData] = useState(persistSearchTerm ? persistSearchTerm :"");
  const [isApiCall, setIsApiCall] = useState<boolean>(false);
  const [meetingFilter, setMeetingFilter] = useState(persistMeetingFilter ? persistMeetingFilter : "");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [sortBy, setSortBy] = useState(
    persistSortBy? persistSortBy:
    {
    id: "Newest first",
    value: "",
    _id: "",
    name: "Newest first",
  });

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (isApiCall) {
      let sortingBy = sortBy?._id?.split("#");
      let finalData = {
        token,
        role: "user",
        limit,
        offset: 0,
        searchData,
        sortBy: sortingBy?.length ? sortingBy[0] : "",
        sortOrder: sortingBy?.length ? sortingBy[1] : "",
        meetUpCompleted:
          meetingFilter === "pending"
            ? false
            : meetingFilter === "completed"
            ? true
            : "",
      };
      dispatchGetClientMeetUpData(finalData);
    }
  }, [sortBy]);

  const handleEditMeetUp = (id: number) => {
    dispatchResetSingleClientMeetUpList();
    history.push({
      pathname: "/lead-module/client-meet-up-check-list/edit",
      state: {
        clientCode: id,
        sortBy,
        searchData,
        meetingFilter
      },
    });
  };

  useEffect(() => {
    dispatchResetSuccess();
    dispatchResetError();
    dispatchResetMessage();
    dispatchResetStatusCode();
    dispatchResetFetching();
    dipatchResetClientMeetUpChecklistAction();
  }, []);

  useEffect(() => {
    if (
      message ===
      "Customer lead Meet up Check List has been updated successfully!"
    ) {
      toast.success("Meet up has been updated Successfully!", {
        duration: 3000,
      });
    }
  }, [message]);

  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        offset < (totalCount ? +totalCount : 0) &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (clientMeetUpChecklistData?.length > 0) {
          if (!fetching && offset < (totalCount ? +totalCount : 0)) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };

  useEffect(() => {
    if (clientMeetUpChecklistData?.length === 0) {
      setData([...clientMeetUpChecklistData]);
    }

    if (offset === 0 && clientMeetUpChecklistData?.length > 0) {
      setData([...clientMeetUpChecklistData]);
    } else if (offset > 0 && !fetching) {
      setData((prv: any) => [...prv, ...clientMeetUpChecklistData]);
    } else {
      if (clientMeetUpChecklistData?.length === 0) {
        setData([...clientMeetUpChecklistData]);
      }
    }
  }, [clientMeetUpChecklistData]);

  useEffect(() => {
    if (token) {
      let sortingBy = sortBy?._id?.split("#");
      let finalData = {
        token,
        role: "user",
        limit,
        offset,
        searchData,
        sortBy: sortingBy?.length ? sortingBy[0] : "",
        sortOrder: sortingBy?.length ? sortingBy[1] : "",
        meetUpCompleted:
          meetingFilter === "pending"
            ? false
            : meetingFilter === "completed"
            ? true
            : "",
      };

      if (offset < +totalCount) {
        setIsApiCall(true);
        dispatchGetClientMeetUpData(finalData);
      } else if (offset === 0 && !fetching && +totalCount === 0) {
        dipatchResetClientMeetUpChecklistAction();
        setData([]);
        dispatchGetClientMeetUpData(finalData);
      }
    }
  }, [offset]);

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [clientMeetUpChecklistData]);

  const handleSearch = (e: any) => {
    let value = e.target.value;
    setSearchData(value);
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetSuccess();
              dispatchResetError();
              dispatchResetMessage();
              dispatchResetStatusCode();
              dispatchResetFetching();
            }}
          />
        );
      }
    }

    return false;
  };

  const handleSort = (data: any) => {
    setOffset(0);
    setSortBy(data);
  };

  const fetchNewData = (searchData: string) => {
    if(offset>0){
      setOffset(0);
    }
    else{
      let sortingBy = sortBy?._id?.split("#");
      const finalData = {
        token,
        role: "user",
        limit,
        offset: 0,
        searchData,
        sortBy: sortingBy?.length ? sortingBy[0] : "",
        sortOrder: sortingBy?.length ? sortingBy[1] : "",
        meetUpCompleted:
          meetingFilter === "pending"
            ? false
            : meetingFilter === "completed"
            ? true
            : "",
      };
      dispatchGetClientMeetUpData(finalData);
    }
  };

  const handleFilter = (data: string) => {
    setMeetingFilter(data);

    setOffset(0);
    let sortingBy = sortBy?._id?.split("#");
    const finalData = {
      token,
      role: "user",
      limit,
      offset: 0,
      searchData,
      sortBy: sortingBy?.length ? sortingBy[0] : "",
      sortOrder: sortingBy?.length ? sortingBy[1] : "",
      meetUpCompleted:
        data === "pending" ? false : data === "completed" ? true : "",
    };
    dispatchGetClientMeetUpData(finalData);
  };

  useDebounce(
    () => {
      if (isApiCall) {
        if (searchData) {
          fetchNewData(searchData);
        } else {
          let sortingBy = sortBy?.id?.split("#");
          const finalData = {
            token,
            role: "user",
            limit,
            offset: 0,
            searchData: "",
            sortBy: sortingBy?.length ? sortingBy[0] : "",
            sortOrder: sortingBy?.length ? sortingBy[1] : "",
            meetUpCompleted:
              meetingFilter === "pending"
                ? false
                : meetingFilter === "completed"
                ? true
                : "",
          };
          dispatchGetClientMeetUpData(finalData);
        }
      }
    },
    500,
    [searchData]
  );

  return windowWidth <= 430 ? (
    <div className="client_meet_up_checklist">
      <div className="bg_white">
        <div className="header">All Client Meetups</div>

        <div className="line"></div>
      </div>

      <div className="client-meet-container">
        <div className="search_sort_container">
          <div className="position-relative mt-3" style={{ width: "85%" }}>
            <span style={{ position: "absolute", top: "4px", left: "12px" }}>
              <SearchIcon />
            </span>
            <input
              className="form-control"
              type="text"
              placeholder="Search client , code , location..."
              onChange={(e: any) => handleSearch(e)}
              style={{ paddingLeft: "36px", height: "30px" }}
              value={searchData}
            />
          </div>

          <div>
 
              <div className="mt-3">
                <ClientMeetUpSorting
                  handleChange={handleSort}
                  selectedData={sortBy}
                />
              </div>
         
          </div>
        </div>

        <div className="fillForm">ALL CLIENT MEETUPS</div>
        <div className="top_filter_container">
          <div
            className={
              meetingFilter === ""
                ? "is_selected filter_style"
                : "not_selected filter_style"
            }
            onClick={() => handleFilter("")}
          >
            <span className="mr-2">
              {
                <img
                  src={
                    meetingFilter === ""
                      ? RectangleWhiteIcon
                      : RectangleRedListIcon
                  }
                  alt="check"
                />
              }
            </span>
            All Checklist
          </div>
          <div
            className={
              meetingFilter === "pending"
                ? "is_selected filter_style"
                : "not_selected filter_style"
            }
            onClick={() => handleFilter("pending")}
          >
            <span className="mr-2">
              {
                <img
                  src={
                    meetingFilter === "pending"
                      ? PendingWhiteIcon
                      : PendingRedIcon
                  }
                  alt="check"
                />
              }
            </span>
            Pending Checklist
          </div>
          <div
            className={
              meetingFilter === "completed"
                ? "is_selected filter_style"
                : "not_selected filter_style"
            }
            onClick={() => handleFilter("completed")}
          >
            <span className="mr-2">
              {
                <img
                  src={
                    meetingFilter === "completed" ? checkedWhiteIcon : checked
                  }
                  alt="check"
                />
              }
            </span>
            Completed Checklist
          </div>
        </div>

        <div className="meet_up_form">
          {fetching ? (
            <TableLoader Rows={8} ColumnPerRow={3} />
          ) : clientMeetUpChecklistData?.length > 0 || data?.length > 0 ? (
            data?.map((item: ClientMeetUpDataType) => {
              return (
                <ClientMeetUpCard
                  item={item}
                  handleEditMeetUp={handleEditMeetUp}
                />
              );
            })
          ) : (
            <div className="mt-4" style={{ paddingTop: "8rem" }}>
              <EmptyListPage title="No Meet Up List Found!" imageWidth="30%" />
            </div>
          )}
        </div>
      </div>

      {handleErrorModal()}
    </div>
  ) : (
    <div className="mt-5">
      <EmptyListPage
        title="Please Login From Mobile Device To Visit This Page"
        image={UnauthorizeImage}
        imageWidth="25%"
      />
    </div>
  );

  <Toaster />;
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.clientDirectory.fetching,
  error: state.clientDirectory.error,
  statusCode: state.clientDirectory.statusCode,
  success: state.clientDirectory.success,
  message: state.clientDirectory.message,
  totalCount: state.clientDirectory.totalCount,
  clientMeetUpChecklistData: state.clientDirectory.clientMeetUpChecklistData,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetSuccess: () => dispatch(resetClientDirectorySuccess()),
  dispatchResetError: () => dispatch(resetClientDirectoryError()),
  dispatchResetMessage: () => dispatch(resetClientDirectoryMessage()),
  dispatchResetStatusCode: () => dispatch(resetClientDirectoryStatusCode()),
  dispatchResetFetching: () => dispatch(resetClientDirectoryFetching()),
  dispatchGetClientMeetUpData: (data: GetClientMeetUpChecklistPayloadType) =>
    dispatch(getClientMeetUpChecklistAction(data)),
  dipatchResetClientMeetUpChecklistAction: () =>
    dispatch(resetClientMeetUpChecklistData()),
  dispatchResetSingleClientMeetUpList: () =>
    dispatch(resetSingleClientMeetUpCheklistData()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientMeetUp);
